


























































 import {Vue, Component, Prop } from 'vue-property-decorator';
 import { DateTime } from 'luxon';

 import UsersListItem from '@share/common/users-list/UsersListItem.vue';
 import StatefullSlot from '@share/meetings-schedule/components/meeting-slot/StatefullSlot.vue';
 import DateSwitcher from '@share/date-switcher/DateSwitcher.vue';
 import TableHead from "./table-parts/Head.vue";
 import TableSlotContainer from "./slot-container/TableSlotContainer.vue"

 import { MScheduleService } from '@share/meetings-schedule/MeetingsScheduleService';
 import { UserProfile } from '@api/models/UserProfile';
 import { getTimeFrames } from '@share/meetings-schedule/stub-data/meetingsSchedule';
 import { MScheduleSlot } from '@api/models/meetings-schedule/MeetingsScheduleSlot';
 import { UserRole } from '@share/meetings-schedule/types/UserRole';
 import { MeetingsSchedule } from '@api/models/meetings-schedule/MeetingsSchedule';
 import { SlotInteractionServiceInterface } from '@share/meetings-schedule/helpers/SlotInteractionService';
 import { BackgroundViewHelper } from '@service/components/background-view/BackgroundViewHelper/BackgroundViewHelper';
 import { BackgroundViewName } from '@service/components/background-view/types/BackgroundViewName';

@Component({
     name: 'MeetingsScheduleMain',
     components: { UsersListItem, StatefullSlot, DateSwitcher, TableHead, TableSlotContainer }
 })
 export default class MeetingsScheduleMain extends Vue {

     @Prop() scheduleService: MScheduleService;
     @Prop() slotService: SlotInteractionServiceInterface;

     updateTimeouts: Record<string, any> = {};
     UserRole = UserRole;

     slotCellsShowing: Record<string, boolean> = {};
     updateIinterval: NodeJS.Timeout;
     show = false;
     userProfileIconSize = 32;

     toggleSlotsShowing(scheduleId: string) {
         if(typeof this.slotCellsShowing[scheduleId] === "boolean") {
             this.slotCellsShowing[scheduleId] = !this.slotCellsShowing[scheduleId];
         }
         else {
             Vue.set(this.slotCellsShowing, scheduleId, false)
         }
     }

     needShowSlots(scheduleId: string) {
         return this.slotCellsShowing[scheduleId] || typeof this.slotCellsShowing[scheduleId] === 'undefined'
     }

     mounted() {
         this.scheduleService?.fetchData(this.eventId);

         window.addEventListener("resize", this.windowResizeHandler);
         this.windowResizeHandler();

         this.startTimeUpdate();
     }

     activated() {
         this.$store.dispatch("setPageTitle", this.$t("common.meetings-schedule"));
     }

     timeframeFilterHandler(timeFrame: DateTime, slots: MScheduleSlot[]) {
         return window.innerWidth < 1023 ? this.getSlotsForTimeFrame(slots, timeFrame).length : true;
     }

     windowResizeHandler() {
         if(window.innerWidth > 1024) {
             this.userProfileIconSize = 44;
         }
         else {
             this.userProfileIconSize = 32;
         }
     }

     async goToAppointment(scheduleId: string) {

         const isBusy = BackgroundViewHelper.checkBroadcastIsBusy(this.$store.state.backgroundView.broadcastQue, '', scheduleId);

         let continueRequest = true;
         if (isBusy) {
             continueRequest = await BackgroundViewHelper.doConfirmModal();
             continueRequest && await this.$store.dispatch("backgroundView/setOffline", BackgroundViewName.session);
         }

         if(continueRequest) {
             //TODO: спрашивать о смене трансляциии если ок то убивать предыдущую
             this.$router.push({
                 name: 'Appointment',
                 params: {
                     ...this.$route.params,
                     id: scheduleId,
                 }
             })
         }
     }

     sort(direction: string) {
         this.scheduleService.sort(direction);
     }

     get timeFrames() {
         if(this.schedules.length) {
             //все начала
             let starts: DateTime[] = [];
             //все концы
             let ends: DateTime[] = [];

             this.schedules.forEach((schedule) => {
                 starts.push(schedule.from)
                 ends.push(schedule.to)
             })

             starts = starts.sort(this.sortHandler);
             ends = ends.sort(this.sortHandler);

             if(starts.length && ends.length) {
                 //выбрать первое начало, выбрать последний конец

                 return getTimeFrames(starts[0], ends[ends.length - 1]).filter((frame) => {
                     return this.schedules.some(({ from, to }) => frame >= from && frame < to)
                 });
             }
         }

         return []
     }

     sortHandler(a: DateTime, b: DateTime) {
         if (a && b) {
             if (a > b) { return 1; }
             if (a < b) { return -1 }
         }
         return 0;
     }

     /**
      * вызывает $forceUpdate в начале каждой минуты
      * для обновления параметра timeIsOver
      */
     startTimeUpdate() {
         const leftSecondsOfMinute = 60 - DateTime.local().get("second");
         setTimeout(() => {
             this.$forceUpdate();
             this.updateIinterval = setInterval(() => {
                 this.$forceUpdate()
             }, 1000 * 60)
         }, leftSecondsOfMinute * 1000)
     }

     getSpeakers(userIds: number[]) {

         const result: UserProfile[] = [];

         userIds.forEach((userId) => {
             if(this.profiles && this.profiles?.has(userId)) {
                 const profile = this.profiles.get(userId)
                 profile && result.push(profile)
             }
         })

         return result;
     }

     checkIsSpeaker(schedule: MeetingsSchedule) {
         return this.scheduleService.getRole(schedule.userIds) === UserRole.speaker
     }

     needShowButton(slots: MScheduleSlot[] | undefined, schedule: MeetingsSchedule): boolean {
         //показывать кнопку админам всегда
         if(this.isAdmin || this.checkIsSpeaker(schedule)) {
             return true;
         }

         if(slots?.length) {
             const bookedSlot = this.getBookedSlot(slots);

             if(bookedSlot) {
                 const now = DateTime.local();
                 const endAt = bookedSlot.endAt as DateTime;

                 //показывать всегда до начала слота
                 //не показывать после окончания слота
                 if(now < endAt) {

                     /**
                     * после момента окончания слота необходимо скрыть кнопку
                     * по-этому выставляем таймаут к моменту окончания слота
                     * что-бы вызвать пересчет DOM и выполнить текущий метод заново
                     */

                     //проверка на наличие таймаута, если есть то не ставить, если нет то записать в объект
                     if(!this.updateTimeouts[bookedSlot.scheduleId]) {

                         const interval = endAt.toMillis() - now.toMillis();

                         if(interval > 0) {
                             const timeOut = setTimeout(() => {
                                 this.$forceUpdate();
                             }, interval)

                             Vue.set(this.updateTimeouts, bookedSlot.scheduleId, timeOut);
                         }
                     }
                     return true;
                 }
                 else {

                     //при наличии таймаута необходимо его убрать
                     this.clearUpdateTimeout(bookedSlot.scheduleId);

                     return false;
                 }
             }
             else {
                 //при наличии таймаута необходимо его убрать, т.к. необходимости в показе кнопки в будущем нет
                 this.clearUpdateTimeout(slots[0].scheduleId);
             }
         }
         return false
     }

     private clearUpdateTimeout(scheduleId: string) {
         if(this.updateTimeouts[scheduleId]) {
             clearTimeout(this.updateTimeouts[scheduleId])
             Vue.delete(this.updateTimeouts, scheduleId);
         }
     }

     private getBookedSlot(slots: MScheduleSlot[]) {
         return slots.find((slot) => slot.ownerId === this.userId);
     }

     getSlotsForTimeFrame(slots: MScheduleSlot[] | undefined, timeFrame: DateTime) {
         /**
          * Тут заполнять слотами только до времени "To" расписания
          */
         return slots?.filter((slot) => {
             return slot.beginAt >= timeFrame.startOf('hour') && slot.endAt <= timeFrame.plus({hours: 1}).startOf('hour')
         }) || [];
     }

     getSlotProfile(userId: number | undefined | null): UserProfile | undefined {
         return userId ? this.profiles?.get(userId) : undefined;
     }

     private getHeaderTimeString(timeFrame: DateTime) {
         return timeFrame.startOf("hour").toFormat("HH:mm")
     }

     private get schedules() {
         return this.scheduleService?.currentSchedules || []
     }

     private get rootSchedules() {
         return this.scheduleService?.rootSchedules || []
     }

     public get slots() {
         return this.scheduleService?.slots || {}
     }

     /** получить список профилей */
     private get profiles() {
         return this.scheduleService.profiles;
     }

     get ownProfile() {
         return this.$store.getters['profile'];
     }

     private get isAdmin(): boolean {
       return this.$store.getters['isAdmin'];
     }

     private get userId() {
         return this.$store.state.session.userId;
     }

     private get eventId() {
         return this.$store.state.events.selected;
     }

     destroyed() {
         clearInterval(this.updateIinterval);
     }
 }
